import { Badge } from '@design-system-etat/dsfr-react';
import React from 'react';
import moment from 'moment';
import { REGEX_DEP_GUYANNE_CALEDONIE_POLYNESIE_MAYOTTE } from '../constants/contraintes.constants';
import { MESSAGE_DATE_NAISSANCE_INVALIDE } from '../constants/messagePersonalise.constants';
import {
    LIBELLE_A_CORRIGER,
    LIBELLE_A_REGULARISER,
    LIBELLE_DETENUE,
    LIBELLE_VALIDER_ACQUISITION,
} from '../components/arme/statuts/StatutsArmes';

/**
 * Permet de générer le message d'erreur à partir du champ manquant
 * @param libelleChamp
 * @returns string message
 */
// eslint-disable-next-line import/prefer-default-export
export const getMessageErreurChampManquant = (libelleChamp) => {
    return `Le champ "${libelleChamp}" est obligatoire.`;
};

export const getMessageErreurChampIncorrect = (libelleChamp) => {
    return `Le champ "${libelleChamp}" n'est pas correcte.`;
};

export const getPatternHookFormValidation = (regex, libelleChamp, messagePersonnalise = null) => {
    if (messagePersonnalise) {
        return {
            value: regex,
            message: messagePersonnalise,
        };
    }

    return {
        value: regex,
        message: `Le champ "${libelleChamp}" possède des caractères interdits.`,
    };
};

export const getValueIsNotNull = (value) => {
    if (value) {
        return value;
    }
    return null;
};

export const validateDateNaissance = (valueDateNaissance) => {
    const dateNaissanceSplit = valueDateNaissance.split('/');
    if (
        dateNaissanceSplit &&
        dateNaissanceSplit.length === 3 &&
        dateNaissanceSplit[2] >= moment().format('YYYY')
    ) {
        return MESSAGE_DATE_NAISSANCE_INVALIDE;
    }
    return null;
};

export const validateDepartement = (valueDepartement, paysNaissance) => {
    if (!valueDepartement && paysNaissance === '75') {
        return getMessageErreurChampManquant('département de Naissance');
    }
    return null;
};

/* Bloquer temporairement les départements suivants:
Guyanne, Nouvelle Calédonie, Polynésie et Mayotte */
export const verifierSiDepartementEstOuvertALaCreationDeCompte = (event) => {
    const res = event && REGEX_DEP_GUYANNE_CALEDONIE_POLYNESIE_MAYOTTE.test(event);

    if (res) {
        return "L'espace détenteur n'est pas encore ouvert aux chasseurs dans votre région";
    }
    return null;
};

// Renvoie TRUE si date1 est plus récente que date2
export const comparerDeuxDates = (date1, date2) => {
    const date1Formatee = date1.split('/');
    const date2Formatee = date2.split('/');

    if (parseInt(date1Formatee[2], 10) > parseInt(date2Formatee[2], 10)) {
        return true;
    }
    if (parseInt(date1Formatee[2], 10) === parseInt(date2Formatee[2], 10)) {
        if (parseInt(date1Formatee[1], 10) > parseInt(date2Formatee[1], 10)) {
            return true;
        }
        if (parseInt(date1Formatee[1], 10) === parseInt(date2Formatee[1], 10)) {
            if (parseInt(date1Formatee[0], 10) > parseInt(date2Formatee[0], 10)) {
                return true;
            }
        }
    }
    return false;
};

export const formaterOptions = (options) => {
    return options.map((option, index) => ({
        name: option.libelle || option.key,
        value: option.value || (index + 1).toString(),
    }));
};

export const displayStatut = (statut) => {
    const mapping = {
        [LIBELLE_A_REGULARISER]: 'info',
        [LIBELLE_VALIDER_ACQUISITION]: 'info',
        [LIBELLE_DETENUE]: 'success',
        [LIBELLE_A_CORRIGER]: 'warning',
    };

    return statut ? <Badge label={statut} size="md" system={mapping[statut]} /> : <></>;
};

export const formaterDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR');
};

export const CLEAR_INFORMATIONS = 'CLEAR_INFORMATIONS';
